import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import UserPresenter from '../presenters/UserPresenter';
import SpecialCashbackRatePresenter from '../presenters/SpecialCashbackRatePresenter';
import IntegrationItemPresenter from '../presenters/FastCash/IntegrationItemPresenter';
import MembershipPresenter from '../presenters/FastCash/MembershipPresenter';
import DatePresenter from '../presenters/DatePresenter';
import { ARCHIVED } from '../presenters/FastCash/MembershipPresenter';
import { amountReadable } from '../utils/functions';

const ACTIVE = 'active';
const BLOCKED = 'blocked';

export const FAST_CASH_STATES = {
  active: ACTIVE,
  blocked: BLOCKED,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    institutionName: PropTypes.string,
    availableCash: PropTypes.number,
    lifetimeCash: PropTypes.number,
    pendingCash: PropTypes.number,
    specialCashbackRate: SpecialCashbackRatePresenter.shape(),
    firstOnboardedAt: PropTypes.string,
    integrationItems: PropTypes.arrayOf(IntegrationItemPresenter.shape()),
    user: UserPresenter.shape(),
    transactionsData: PropTypes.shape(),
    cashbacksData: PropTypes.shape(),
    blockedState: PropTypes.string,
    meta: PropTypes.shape(),
    latestMembershipState: PropTypes.string,
    memberships: PropTypes.arrayOf(MembershipPresenter.shape()),
    paymentsTotalAmount: PropTypes.number,
    bonusesTotalAmount: PropTypes.number,
  },
  {
    plaidState(fastCash) {
      if (this.errorState(fastCash) === 'false') {
        return 'Plaid account is in good state';
      }

      return `Plaid account is in error state. Error: ${this.errorCode(
        fastCash
      )}`;
    },
    accountOnboardedAtReadable(fastCash) {
      return DatePresenter.dateReadable(this.accountOnboardedAt(fastCash));
    },
    firstOnboardedAtReadable(fastCash) {
      return DatePresenter.dateReadable(this.firstOnboardedAt(fastCash));
    },
    isBlocked(fastCash) {
      return this.blockedState(fastCash) == BLOCKED;
    },
    latestMembershipStateReadable(fastCash) {
      const latestMembershipState = this.latestMembershipState(fastCash);

      return isNil(latestMembershipState) ? '--' : `${latestMembershipState}`;
    },
    latestMembershipStateReadableWithSlash(fastCash) {
      return `${this.latestMembershipStateReadable(fastCash)} \/ `;
    },
    paymentsTotalAmountReadable(fastCash) {
      const paymentsTotalAmount = this.paymentsTotalAmount(fastCash);

      return amountReadable(paymentsTotalAmount);
    },
    bonusesTotalAmountReadable(fastCash) {
      const bonusesTotalAmount = this.bonusesTotalAmount(fastCash);

      return amountReadable(bonusesTotalAmount);
    },
    isLastMembershipArchived(fastCash) {
      return this.latestMembershipState(fastCash) == ARCHIVED;
    },
  }
);
